import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isFunction, each } from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { SummaryBarContainer } from '@bingads-webui-react/summary-bar';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { SimpleBreadcrumb } from './components/simple-breadcrumb';
import { getSimpleSummaryBarStyle } from './styles';

const isHideBreadCrumbBack = (backButtonText, i18n) => backButtonText !== i18n.getString(_TL_('Back to campaigns'))
&& backButtonText !== i18n.getString(_TL_('Back to accounts'));

class SimpleSummaryBarInternal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.customSummaryBarItemsRef = React.createRef();
  }

  componentDidUpdate() {
    if (this.customSummaryBarItemsRef && this.customSummaryBarItemsRef.current) {
      this.customSummaryBarItemsRef.current.innerText = '';
    }
  }

  render() {
    const {
      i18n,
      selectedParent,
      breadCrumbText,
      backButtonText,
      backButtonUrl,
      onClickBackButton,
      customSummaryBarItemsId,
      isVisible,
      additionalPrefixItems,
      additionalItems,
      onClick,
      showTag,
      tagClass,
      permissions,
    } = this.props;
    const buttonText = backButtonText === null ? i18n.getString(_TL_('Back')) : backButtonText;
    const backButtonProps = isHideBreadCrumbBack(backButtonText, i18n) ? Object.assign({
      url: backButtonUrl,
      buttonText,
    }, onClickBackButton ? {
      onClick: onClickBackButton,
    } : {}) : null;
    each(additionalItems, (additionalItem, index) => {
      if (!isFunction(additionalItem.onClick)) {
        additionalItems[index].onClick = null;
      }
    });
    const breadcrumb = (!isEmpty(breadCrumbText) || selectedParent) ? (
      <SimpleBreadcrumb
        selectedItem={selectedParent}
        maxDisplayedItems={3}
        breadCrumbText={breadCrumbText}
        i18n={i18n}
        breadcrumbUrl={this.props.breadcrumbUrl}
        additionalPrefixItems={additionalPrefixItems}
        additionalItems={this.props.additionalItems}
        onClick={isFunction(onClick) ? onClick : null}
        showTag={showTag}
        tagClass={tagClass}
      />
    ) : null;
    const summaryBar = customSummaryBarItemsId ? (
      <div ref={this.customSummaryBarItemsRef} id={customSummaryBarItemsId} />
    ) : null;

    return isVisible ? (
      <SummaryBarContainer
        texts={{
          ariaLabel: i18n.getString(_TL_('Summary bar')),
        }}
        backButtonProps={backButtonProps}
        breadcrumb={breadcrumb}
        summaryBar={summaryBar}
        showScopeBackButton={isNavigationRefreshOn(permissions)}
        i18n={i18n}
      />
    ) : null;
  }
}

SimpleSummaryBarInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  selectedParent: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }),
  breadCrumbText: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonUrl: PropTypes.string,
  onClickBackButton: PropTypes.func,
  breadcrumbUrl: PropTypes.string,
  additionalPrefixItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })),
  additionalItems: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    text: PropTypes.string,
  })),
  customSummaryBarItemsId: PropTypes.string,
  isVisible: PropTypes.bool,
  onClick: PropTypes.func,
  showTag: PropTypes.string,
  tagClass: PropTypes.string,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

SimpleSummaryBarInternal.defaultProps = {
  breadCrumbText: null,
  backButtonText: null,
  backButtonUrl: null,
  onClickBackButton: null,
  selectedParent: null,
  breadcrumbUrl: null,
  additionalPrefixItems: [],
  additionalItems: [],
  customSummaryBarItemsId: null,
  isVisible: true,
  onClick: null,
  showTag: '',
  tagClass: '',
};

export const SimpleSummaryBar = withPermissions(withI18nConsumer(withDefaultStyles(
  SimpleSummaryBarInternal,
  getSimpleSummaryBarStyle
)));
